export const getUserRowsPerPage = (user, fallback = 5) => {
  const rows_per_page = user?.settings?.rpp;

  if (Number.isFinite(rows_per_page) && rows_per_page > 0) {
    return rows_per_page;
  }

  return typeof fallback === "number" &&
    Number.isFinite(fallback) &&
    fallback > 0
    ? fallback
    : 5;
};
